import Badge from "@/components/design-system/badge";
import type { VendorPurchase } from "@/store/sellerOptionsSlice";
import ClockIcon from "public/next-public/common/icons/clock-solid.svg";

/** For an offer from a seller the signed-in shopper has bought from before, on any order. */
function PurchasedFromBeforeBadge({ vendorName, purchase }: PurchasedFromBeforeBadgeProps) {
  return (
    <Badge
      label="Purchased From Before"
      color="blue"
      size="small"
      strong={false}
      icon={<ClockIcon width={12} height={12} aria-hidden />}
      tooltip={describePurchases(vendorName, purchase)}
      tooltipPlacement="below"
    />
  );
}

export default PurchasedFromBeforeBadge;

export function describePurchases(vendorName: string, { totalPurchases, lastPurchasedOn }: VendorPurchase): string {
  if (totalPurchases === null || lastPurchasedOn === null) {
    return `You’ve purchased from ${vendorName} before.`;
  }
  return `You’ve purchased from ${vendorName} ${totalPurchases} ${totalPurchases === 1 ? "time" : "times"} before, most recently on ${lastPurchasedOn}.`;
}

interface PurchasedFromBeforeBadgeProps {
  vendorName: string;
  purchase: VendorPurchase;
}
